import { Provider } from "../../../classes/provider/Provider";

const googleProvider = new Provider({
	id: "google",
	name: "Google",
	description:
		"Google has a variety of services, including Gmail, Google Drive, Google Photos, and Google Calendar.",
	websiteHomeUrl: "https://google.com/",
	websiteSupportUrl: "https://support.google.com",
	iconUrl:
		"https://storage.googleapis.com/cdn.version2.io/providers/google.png",
	color: "#FFFFFF",
});

export default googleProvider;
